// src/utils/colorUtils.ts

// A palette of approximately 20 distinct and visually appealing colors
export const COLOR_PALETTE = [
  '#FF5733', '#33FF57', '#3357FF', '#FF33A1', '#A133FF',
  '#33FFF5', '#F5FF33', '#FF8C33', '#33FF8C', '#8C33FF',
  '#FF3333', '#33A1FF', '#FF33F5', '#F533FF', '#33FF33',
  '#FFD133', '#D133FF', '#33FFD1', '#D1FF33', '#FF338C'
];

const normalizePaletteIndex = (authorId: number): number =>
  (authorId % COLOR_PALETTE.length + COLOR_PALETTE.length) % COLOR_PALETTE.length;

const normalizeRgbChannel = (value: number): number => value / 255;

export const getAuthorColor = (authorId: number, authorColor?: string): string => {
  if (authorColor) {
    return authorColor;
  }
  return COLOR_PALETTE[normalizePaletteIndex(authorId)];
};

export const hexToRgb = (hex: string) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return { r, g, b };
};

export const hexToHsl = (hex: string) => {
  const { r, g, b } = hexToRgb(hex);

  const r_norm = normalizeRgbChannel(r);
  const g_norm = normalizeRgbChannel(g);
  const b_norm = normalizeRgbChannel(b);

  const max = Math.max(r_norm, g_norm, b_norm);
  const min = Math.min(r_norm, g_norm, b_norm);

  let h = 0;
  let s = 0;
  const l = (max + min) / 2;

  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r_norm:
        h = (g_norm - b_norm) / d + (g_norm < b_norm ? 6 : 0);
        break;
      case g_norm:
        h = (b_norm - r_norm) / d + 2;
        break;
      case b_norm:
        h = (r_norm - g_norm) / d + 4;
        break;
    }
    h /= 6;
  }

  return { h: h * 360, s: s * 100, l: l * 100 };
};
